export const adaptYupErrors = ({ inner = [] }) => {
  return inner.reduce((acc, { path, message }) => {
    return {
      ...acc,
      [path]: message,
    };
  }, {});
};
